import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 30 30" {...props}><path fill="currentColor" d="M15 6.3C7.5 6.3 2.5 15 2.5 15s5 8.7 12.5 8.7S27.5 15 27.5 15s-5-8.7-12.5-8.7zm0 14.8c-3.4 0-6.1-2.8-6.1-6.1 0-3.4 2.8-6.1 6.1-6.1 3.4 0 6.1 2.8 6.1 6.1 0 3.4-2.7 6.1-6.1 6.1z" /><path fill="currentColor" d="M15 12.3c-1.5 0-2.7 1.3-2.7 2.8 0 1.5 1.2 2.7 2.7 2.7 1.5 0 2.8-1.2 2.8-2.7 0-1.6-1.3-2.8-2.8-2.8z" /></svg>);